import { merge } from 'lodash-es';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

const getInitialState = () => ({
  tiers: {
    tier0: false,
    tier1: false,
    tier2: false,
    tier3: false
  }
});

export default {
  namespaced: true,
  state: getInitialState,
  getters: {
    tiers: _state => _state.tiers
  },
  mutations: {
    FETCH_ENCRYPTION_SUCCESS(state, payload) {
      if (payload?.encryption) {
        state.tiers = merge({}, state.tiers, payload.encryption);
      }
    },
    FETCH_ENCRYPTION_ERROR() {
      return null;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_ENCRYPTION({ commit }) {
      return getClusterId()
        .then(clusterId => this.$api.get(`/api/v2/${clusterId}/settings`))
        .then((response) => {
          commit('FETCH_ENCRYPTION_SUCCESS', response.data);
          return response;
        })
        .catch((error) => {
          commit('FETCH_ENCRYPTION_ERROR', error?.data);
          throw error;
        });
    },
    SAVE_ENCRYPTION({ commit }, tiers) {
      return getClusterId()
        .then(clusterId => this.$api.put(`/api/v2/${clusterId}/settings`, { encryption: tiers }))
        .then((response) => {
          commit('FETCH_ENCRYPTION_SUCCESS', response.data);
          return response;
        })
        .catch((error) => {
          commit('FETCH_ENCRYPTION_ERROR', error?.data);
          throw error;
        });
    }
  }
};
